import Typography from '@ixigo/iui/Typography';
import { FC } from 'react';
import { ServiceListProps } from './index.types';

const WebServiceList: FC<ServiceListProps> = ({ data, onClick }) => (
    <div className='grid grid-cols-3 gap-30 pt-20'>
        {data.map((item) => (
            <div key={item._id} className='flex flex-col gap-5 cursor-pointer' onClick={() => onClick(item)}>
                <div dangerouslySetInnerHTML={{ __html: item.iconSvg }} />
                <div>
                    <Typography variant='body-md' fontWeight='medium'>
                        {item.header}
                    </Typography>
                    <Typography className='text-charcoal-600'>{item.subHeader}</Typography>
                </div>
            </div>
        ))}
    </div>
);

export default WebServiceList;
